module.exports = __webpack_public_path__ + "static/media/main-img2-final.1507ca34.png";